var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconHostevent48 = function SvgAIconHostevent48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    stroke: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9998 47C42.0748 47 46.9995 42.0751 46.9995 36C46.9995 29.9249 42.0748 25 35.9998 25C29.9248 25 25 29.9249 25 36C25 42.0751 29.9248 47 35.9998 47Z",
    fill: "#F4EEF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 32.0003H3.72727C2.22104 32.0003 1 30.7467 1 29.2003V6.80003C1 5.25362 2.22104 4 3.72727 4H28.2727C29.779 4 31 5.25362 31 6.80003V15",
    stroke: "#5C068C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12H31",
    stroke: "#5C068C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 1L23 7",
    stroke: "#5C068C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1L9 7",
    stroke: "#5C068C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9998 43C37.0748 43 41.9995 38.0751 41.9995 32C41.9995 25.9249 37.0748 21 30.9998 21C24.9248 21 20 25.9249 20 32C20 38.0751 24.9248 43 30.9998 43Z",
    stroke: "#5C068C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32H36",
    stroke: "#5C068C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37L31 27",
    stroke: "#5C068C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconHostevent48 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiBmaWxsPSJub25lIiBzdHJva2U9Im5vbmUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM1Ljk5OTggNDdDNDIuMDc0OCA0NyA0Ni45OTk1IDQyLjA3NTEgNDYuOTk5NSAzNkM0Ni45OTk1IDI5LjkyNDkgNDIuMDc0OCAyNSAzNS45OTk4IDI1QzI5LjkyNDggMjUgMjUgMjkuOTI0OSAyNSAzNkMyNSA0Mi4wNzUxIDI5LjkyNDggNDcgMzUuOTk5OCA0N1oiIGZpbGw9IiNGNEVFRjciIC8+CjxwYXRoIGQ9Ik0xNCAzMi4wMDAzSDMuNzI3MjdDMi4yMjEwNCAzMi4wMDAzIDEgMzAuNzQ2NyAxIDI5LjIwMDNWNi44MDAwM0MxIDUuMjUzNjIgMi4yMjEwNCA0IDMuNzI3MjcgNEgyOC4yNzI3QzI5Ljc3OSA0IDMxIDUuMjUzNjIgMzEgNi44MDAwM1YxNSIgc3Ryb2tlPSIjNUMwNjhDIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTEgMTJIMzEiIHN0cm9rZT0iIzVDMDY4QyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0yMyAxTDIzIDciIHN0cm9rZT0iIzVDMDY4QyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik05IDFMOSA3IiBzdHJva2U9IiM1QzA2OEMiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTMwLjk5OTggNDNDMzcuMDc0OCA0MyA0MS45OTk1IDM4LjA3NTEgNDEuOTk5NSAzMkM0MS45OTk1IDI1LjkyNDkgMzcuMDc0OCAyMSAzMC45OTk4IDIxQzI0LjkyNDggMjEgMjAgMjUuOTI0OSAyMCAzMkMyMCAzOC4wNzUxIDI0LjkyNDggNDMgMzAuOTk5OCA0M1oiIHN0cm9rZT0iIzVDMDY4QyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0yNiAzMkgzNiIgc3Ryb2tlPSIjNUMwNjhDIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTMxIDM3TDMxIDI3IiBzdHJva2U9IiM1QzA2OEMiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4K";